var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSentmoThinking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9"
    },
    d: "M460.779,397.506c7.336-15.772,10.58-33.324,12.829-50.371 c6.207-47.026,3.728-95.362-9.846-141.094C432.809,101.762,373.286,39.495,297.889,32.743 c-75.397-6.752-147.619,33.759-175.397,110.28C94.714,219.544,16.143,283.312,29.635,345.579 c13.492,62.267,72.222,105.028,188.095,119.282c50.476,6.209,103.914,9.008,153.619-3.476 c28.373-7.126,56.264-20.915,75.426-42.35C452.655,412.459,457.203,405.194,460.779,397.506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M460.779,397.506c7.336-15.772,10.58-33.324,12.829-50.371 c6.207-47.026,3.728-95.362-9.846-141.094C432.809,101.762,373.286,39.495,297.889,32.743 c-75.397-6.752-147.619,33.759-175.397,110.28C94.714,219.544,16.143,283.312,29.635,345.579 c13.492,62.267,72.222,105.028,188.095,119.282c50.476,6.209,103.914,9.008,153.619-3.476 c28.373-7.126,56.264-20.915,75.426-42.35C452.655,412.459,457.203,405.194,460.779,397.506z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 470.231,
    y1: 421,
    x2: 483,
    y2: 421
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 97.007,
    y1: 421,
    x2: 462.527,
    y2: 421
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 23,
    y1: 421,
    x2: 85.879,
    y2: 421
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Geometric_Shapes"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 250.102,
    y: 116.245,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.814,
    height: 14.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.436,
    y: 140.911,
    transform: "matrix(0.7534 -0.6576 0.6576 0.7534 -25.8079 227.818)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.814,
    height: 14.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.102,
    y: 74.911,
    transform: "matrix(0.7534 -0.6575 0.6575 0.7534 -2.959 156.746)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.814,
    height: 14.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.102,
    y: 134.911,
    transform: "matrix(0.7534 -0.6575 0.6575 0.7534 -42.412 171.5413)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.814,
    height: 14.814
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.102,
    y: 74.245,
    transform: "matrix(0.7534 -0.6576 0.6576 0.7534 13.7547 199.9811)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 14.814,
    height: 14.814
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 263.395,141.125 266.535,147.487 273.556,148.507 268.475,153.459 269.675,160.451 263.395,157.15 257.116,160.451  258.315,153.459 253.235,148.507 260.255,147.487  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 209.92,95.999 213.059,102.361 220.08,103.381 215,108.333 216.199,115.326 209.92,112.024 203.64,115.326 204.839,108.333  199.759,103.381 206.78,102.361  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 302.634,60.713 300.472,67.47 304.812,73.082 297.717,73.113 293.721,78.975 291.499,72.238 284.689,70.248 290.41,66.053  290.198,58.962 295.956,63.107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 255.322,172.81 262.363,173.684 267.074,168.379 268.419,175.345 274.919,178.186 268.71,181.618 268.017,188.678  262.834,183.833 255.905,185.356 258.911,178.93  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2308 -0.973 0.973 0.2308 100.8997 370.4555)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 284.75,
    cy: 121.412,
    rx: 10.412,
    ry: 10.412
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -61.1368 227.736)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 244.333,
    cy: 187.667,
    rx: 10.412,
    ry: 10.412
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9366 -0.3504 0.3504 0.9366 -11.1783 116.7194)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 317,
    cy: 89.254,
    rx: 10.412,
    ry: 10.412
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2308 -0.973 0.973 0.2308 84.1914 311.9872)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 239.416,
    cy: 102.746,
    rx: 10.412,
    ry: 10.412
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 239.952,134.52 223.312,124.064 222.576,143.702  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 317.874,127.481 314.687,108.088 299.486,120.545  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 246.272,171.101 247.063,151.465 229.662,160.598  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 297.034,105.07 297.825,85.433 280.424,94.566  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 229.094,67.478 239.341,84.248 248.741,66.989  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M392.561,153.104c-0.13,0-0.256-0.051-0.349-0.142c-0.097-0.094-0.151-0.223-0.151-0.358v-6.493 c0-3.322-0.314-15.02-0.317-15.138c-0.007-0.27,0.2-0.497,0.47-0.513c0.079-0.005,8.044-0.483,14.661-0.241 c6.573,0.236,10.079,0.003,10.115,0.001c0.131-0.004,0.267,0.036,0.367,0.126c0.101,0.09,0.16,0.216,0.167,0.351l0.953,21.645 c0.006,0.136-0.044,0.269-0.139,0.368c-0.095,0.099-0.225,0.154-0.361,0.154H406.54c-4.391,0-13.871,0.238-13.966,0.24 C392.57,153.104,392.565,153.104,392.561,153.104z M392.757,131.432c0.06,2.258,0.305,11.734,0.305,14.679v5.981 c2.043-0.05,9.668-0.228,13.479-0.228h10.915l-0.908-20.619c-1.205,0.056-4.518,0.162-9.707-0.026 C401.201,131.014,394.576,131.333,392.757,131.432z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M408.753,132.534c0-0.918-0.745-1.663-1.663-1.663c-0.918,0-1.663,0.744-1.663,1.663c0,0.918,0.745,1.663,1.663,1.663 C408.008,134.196,408.753,133.452,408.753,132.534z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 409.03,
    cy: 131.393,
    r: 1.663
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M405.039,134.615c-0.137,0-0.272-0.056-0.371-0.165c-0.186-0.205-0.169-0.521,0.036-0.706l1.141-1.027 c0.204-0.186,0.521-0.168,0.706,0.037c0.186,0.205,0.169,0.521-0.036,0.706l-1.141,1.027 C405.278,134.572,405.158,134.615,405.039,134.615z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M410.754,139.129h-12.898c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h12.898c0.276,0,0.5,0.224,0.5,0.5 C411.254,138.906,411.03,139.129,410.754,139.129z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M411.513,143.429h-13.657c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h13.657c0.276,0,0.5,0.224,0.5,0.5 S411.789,143.429,411.513,143.429z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M411.766,147.476h-13.91c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h13.91c0.276,0,0.5,0.224,0.5,0.5 S412.042,147.476,411.766,147.476z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M456.05,226.388c-0.13,0-0.256-0.051-0.349-0.142c-0.097-0.094-0.151-0.223-0.151-0.358v-6.493 c0-3.322-0.314-15.02-0.317-15.138c-0.007-0.27,0.2-0.497,0.47-0.513c0.079-0.005,8.044-0.483,14.661-0.241 c6.573,0.236,10.079,0.003,10.115,0c0.131-0.004,0.267,0.036,0.367,0.126c0.101,0.09,0.16,0.216,0.167,0.351l0.953,21.645 c0.006,0.136-0.044,0.269-0.139,0.368c-0.095,0.099-0.225,0.154-0.361,0.154h-11.438c-4.391,0-13.871,0.238-13.966,0.24 C456.059,226.388,456.054,226.388,456.05,226.388z M456.245,204.716c0.06,2.258,0.305,11.734,0.305,14.679v5.981 c2.043-0.05,9.668-0.228,13.479-0.228h10.915l-0.908-20.619c-1.205,0.056-4.518,0.162-9.707-0.026 C464.69,204.298,458.065,204.618,456.245,204.716z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472.241,205.818c0-0.918-0.744-1.663-1.663-1.663s-1.663,0.744-1.663,1.663s0.744,1.663,1.663,1.663 S472.241,206.736,472.241,205.818z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M474.181,204.677c0-0.918-0.744-1.663-1.663-1.663s-1.663,0.745-1.663,1.663c0,0.918,0.744,1.663,1.663,1.663 S474.181,205.595,474.181,204.677z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M468.528,207.899c-0.137,0-0.272-0.056-0.371-0.165c-0.186-0.205-0.169-0.521,0.036-0.706l1.141-1.027 c0.204-0.186,0.522-0.169,0.706,0.037c0.185,0.205,0.169,0.521-0.036,0.706l-1.141,1.027 C468.767,207.856,468.647,207.899,468.528,207.899z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M474.242,212.414h-12.898c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h12.898c0.276,0,0.5,0.224,0.5,0.5 C474.742,212.19,474.519,212.414,474.242,212.414z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M475.001,216.713h-13.657c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h13.657c0.276,0,0.5,0.224,0.5,0.5 C475.501,216.489,475.278,216.713,475.001,216.713z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M475.254,220.76h-13.91c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h13.91c0.276,0,0.5,0.224,0.5,0.5 C475.754,220.536,475.531,220.76,475.254,220.76z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.011,190.351c-0.13,0-0.256-0.051-0.349-0.142c-0.097-0.094-0.151-0.223-0.151-0.358v-6.493 c0-3.322-0.314-15.02-0.317-15.138c-0.007-0.27,0.2-0.497,0.47-0.513c0.079-0.005,8.044-0.483,14.661-0.241 c6.573,0.236,10.079,0.003,10.115,0.001c0.131-0.004,0.267,0.036,0.367,0.126c0.101,0.09,0.16,0.216,0.167,0.351l0.953,21.645 c0.006,0.136-0.044,0.269-0.139,0.368c-0.095,0.099-0.225,0.154-0.361,0.154h-11.438c-4.391,0-13.871,0.238-13.966,0.24 C161.02,190.351,161.015,190.351,161.011,190.351z M161.206,168.679c0.059,2.258,0.305,11.734,0.305,14.679v5.981 c2.043-0.05,9.668-0.228,13.479-0.228h10.915l-0.908-20.619c-1.205,0.056-4.518,0.162-9.707-0.026 C169.65,168.261,163.025,168.581,161.206,168.679z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M177.202,169.781c0-0.918-0.744-1.663-1.663-1.663c-0.918,0-1.663,0.745-1.663,1.663c0,0.918,0.744,1.663,1.663,1.663 C176.457,171.443,177.202,170.699,177.202,169.781z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.142,168.639c0-0.918-0.745-1.663-1.663-1.663c-0.918,0-1.663,0.744-1.663,1.663c0,0.918,0.744,1.663,1.663,1.663 C178.397,170.302,179.142,169.558,179.142,168.639z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M173.488,171.862c-0.137,0-0.273-0.056-0.371-0.165c-0.186-0.205-0.169-0.521,0.036-0.706l1.141-1.027 c0.204-0.186,0.521-0.169,0.706,0.037c0.186,0.205,0.169,0.521-0.036,0.706l-1.141,1.027 C173.727,171.819,173.607,171.862,173.488,171.862z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.203,176.376h-12.898c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h12.898c0.276,0,0.5,0.224,0.5,0.5 C179.703,176.153,179.479,176.376,179.203,176.376z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.962,180.676h-13.657c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h13.657c0.276,0,0.5,0.224,0.5,0.5 C180.462,180.452,180.238,180.676,179.962,180.676z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M180.215,184.723h-13.91c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h13.91c0.276,0,0.5,0.224,0.5,0.5 C180.715,184.499,180.491,184.723,180.215,184.723z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M357.865,186.045c-0.13,0-0.256-0.051-0.349-0.142c-0.097-0.094-0.151-0.223-0.151-0.358v-6.493 c0-3.322-0.314-15.02-0.317-15.138c-0.007-0.27,0.2-0.497,0.47-0.513c0.079-0.005,8.044-0.483,14.661-0.241 c6.573,0.236,10.079,0.003,10.115,0.001c0.131-0.004,0.267,0.036,0.367,0.126c0.101,0.09,0.16,0.216,0.167,0.351l0.953,21.645 c0.006,0.136-0.044,0.269-0.139,0.368c-0.095,0.099-0.225,0.154-0.361,0.154h-11.438c-4.391,0-13.871,0.238-13.966,0.24 C357.874,186.045,357.869,186.045,357.865,186.045z M358.06,164.372c0.06,2.258,0.305,11.734,0.305,14.679v5.981 c2.043-0.05,9.668-0.228,13.479-0.228h10.915l-0.908-20.619c-1.205,0.056-4.518,0.162-9.707-0.026 C366.504,163.955,359.879,164.274,358.06,164.372z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M374.056,165.475c0-0.918-0.744-1.663-1.663-1.663c-0.918,0-1.663,0.745-1.663,1.663c0,0.918,0.744,1.663,1.663,1.663 C373.312,167.137,374.056,166.393,374.056,165.475z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M375.996,164.333c0-0.918-0.745-1.663-1.663-1.663c-0.918,0-1.663,0.744-1.663,1.663s0.744,1.663,1.663,1.663 C375.252,165.996,375.996,165.252,375.996,164.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M370.342,167.556c-0.137,0-0.272-0.056-0.371-0.165c-0.186-0.205-0.169-0.521,0.036-0.706l1.141-1.027 c0.204-0.186,0.521-0.168,0.706,0.037c0.185,0.205,0.169,0.521-0.036,0.706l-1.141,1.027 C370.582,167.513,370.461,167.556,370.342,167.556z"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M376.057,172.07h-12.898c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h12.898c0.276,0,0.5,0.224,0.5,0.5 C376.557,171.847,376.334,172.07,376.057,172.07z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M376.816,176.37h-13.657c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h13.657c0.276,0,0.5,0.224,0.5,0.5 C377.316,176.146,377.092,176.37,376.816,176.37z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.069,180.416h-13.91c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h13.91c0.276,0,0.5,0.224,0.5,0.5 C377.569,180.193,377.345,180.416,377.069,180.416z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M419.198,186.045c-0.13,0-0.256-0.051-0.349-0.142c-0.097-0.094-0.151-0.223-0.151-0.358v-6.493 c0-3.322-0.314-15.02-0.317-15.138c-0.007-0.27,0.2-0.497,0.47-0.513c0.079-0.005,8.044-0.483,14.661-0.241 c6.573,0.236,10.079,0.003,10.115,0.001c0.131-0.004,0.267,0.036,0.367,0.126c0.101,0.09,0.16,0.216,0.167,0.351l0.953,21.645 c0.006,0.136-0.044,0.269-0.139,0.368c-0.095,0.099-0.225,0.154-0.361,0.154h-11.438c-4.391,0-13.871,0.238-13.966,0.24 C419.207,186.045,419.202,186.045,419.198,186.045z M419.393,164.372c0.06,2.258,0.305,11.734,0.305,14.679v5.981 c2.043-0.05,9.668-0.228,13.479-0.228h10.915l-0.908-20.619c-1.205,0.056-4.518,0.162-9.707-0.026 C427.838,163.955,421.213,164.274,419.393,164.372z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M435.389,165.475c0-0.918-0.744-1.663-1.663-1.663s-1.663,0.745-1.663,1.663c0,0.918,0.744,1.663,1.663,1.663 S435.389,166.393,435.389,165.475z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437.329,164.333c0-0.918-0.744-1.663-1.663-1.663s-1.663,0.744-1.663,1.663s0.745,1.663,1.663,1.663 S437.329,165.252,437.329,164.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M431.676,167.556c-0.137,0-0.272-0.056-0.371-0.165c-0.186-0.205-0.169-0.521,0.036-0.706l1.141-1.027 c0.204-0.186,0.522-0.168,0.706,0.037c0.186,0.205,0.169,0.521-0.036,0.706l-1.141,1.027 C431.915,167.513,431.795,167.556,431.676,167.556z"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M437.391,172.07h-12.898c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h12.898c0.276,0,0.5,0.224,0.5,0.5 C437.891,171.847,437.667,172.07,437.391,172.07z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M438.149,176.37h-13.657c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h13.657c0.276,0,0.5,0.224,0.5,0.5 C438.649,176.146,438.426,176.37,438.149,176.37z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M438.402,180.416h-13.91c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h13.91c0.276,0,0.5,0.224,0.5,0.5 C438.902,180.193,438.679,180.416,438.402,180.416z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M430.38,134.645c-0.13,0-0.256-0.051-0.349-0.142c-0.097-0.094-0.151-0.223-0.151-0.358v-6.493 c0-3.322-0.314-15.02-0.317-15.138c-0.007-0.27,0.2-0.497,0.47-0.513c0.079-0.005,8.044-0.483,14.661-0.241 c6.573,0.236,10.079,0.004,10.115,0.001c0.131-0.004,0.267,0.036,0.367,0.126c0.101,0.09,0.16,0.216,0.167,0.351l0.953,21.645 c0.006,0.136-0.044,0.269-0.139,0.368c-0.095,0.099-0.225,0.154-0.361,0.154h-11.438c-4.391,0-13.871,0.238-13.966,0.24 C430.389,134.645,430.384,134.645,430.38,134.645z M430.576,112.973c0.06,2.258,0.305,11.734,0.305,14.679v5.981 c2.043-0.05,9.668-0.228,13.479-0.228h10.915l-0.908-20.619c-1.205,0.056-4.518,0.162-9.707-0.026 C439.02,112.555,432.395,112.874,430.576,112.973z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M446.571,114.075c0-0.918-0.745-1.663-1.663-1.663c-0.918,0-1.663,0.744-1.663,1.663s0.744,1.663,1.663,1.663 C445.827,115.737,446.571,114.993,446.571,114.075z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 446.849,
    cy: 112.934,
    r: 1.663
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M442.858,116.156c-0.137,0-0.272-0.056-0.371-0.166c-0.186-0.205-0.169-0.521,0.036-0.706l1.141-1.027 c0.204-0.186,0.521-0.168,0.706,0.037c0.186,0.205,0.169,0.521-0.036,0.706l-1.141,1.027 C443.097,116.113,442.977,116.156,442.858,116.156z"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M448.573,120.67h-12.898c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h12.898c0.276,0,0.5,0.224,0.5,0.5 C449.073,120.447,448.849,120.67,448.573,120.67z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M449.331,124.97h-13.657c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h13.657c0.276,0,0.5,0.224,0.5,0.5 C449.831,124.746,449.608,124.97,449.331,124.97z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M449.584,129.017h-13.91c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h13.91c0.276,0,0.5,0.224,0.5,0.5 S449.861,129.017,449.584,129.017z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.714,129.312c-0.13,0-0.256-0.051-0.349-0.142c-0.097-0.094-0.151-0.223-0.151-0.358v-6.493 c0-3.322-0.314-15.02-0.317-15.138c-0.007-0.27,0.2-0.497,0.47-0.513c0.079-0.005,8.044-0.483,14.661-0.241 c6.573,0.236,10.079,0.003,10.115,0.001c0.131-0.004,0.267,0.036,0.367,0.126c0.101,0.09,0.16,0.216,0.167,0.351l0.953,21.645 c0.006,0.136-0.044,0.269-0.139,0.368c-0.095,0.099-0.225,0.154-0.361,0.154h-11.438c-4.391,0-13.871,0.238-13.966,0.24 C353.722,129.312,353.717,129.312,353.714,129.312z M353.909,107.639c0.059,2.258,0.305,11.734,0.305,14.679v5.981 c2.043-0.05,9.668-0.228,13.479-0.228h10.915l-0.908-20.619c-1.205,0.056-4.518,0.162-9.707-0.026 C362.353,107.222,355.728,107.541,353.909,107.639z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 368.242,
    cy: 108.741,
    r: 1.663
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M371.845,107.6c0-0.918-0.745-1.663-1.663-1.663c-0.918,0-1.663,0.744-1.663,1.663c0,0.918,0.744,1.663,1.663,1.663 C371.1,109.263,371.845,108.519,371.845,107.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M366.191,110.822c-0.137,0-0.273-0.056-0.371-0.166c-0.186-0.205-0.169-0.521,0.036-0.706l1.141-1.027 c0.204-0.186,0.521-0.169,0.706,0.037c0.186,0.205,0.169,0.521-0.036,0.706l-1.141,1.027 C366.43,110.78,366.31,110.822,366.191,110.822z"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M371.906,115.337h-12.898c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h12.898c0.276,0,0.5,0.224,0.5,0.5 C372.406,115.113,372.182,115.337,371.906,115.337z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M372.665,119.636h-13.657c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h13.657c0.276,0,0.5,0.224,0.5,0.5 C373.165,119.413,372.941,119.636,372.665,119.636z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M372.918,123.683h-13.91c-0.276,0-0.5-0.224-0.5-0.5c0-0.276,0.224-0.5,0.5-0.5h13.91c0.276,0,0.5,0.224,0.5,0.5 C373.418,123.46,373.194,123.683,372.918,123.683z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.333,
    y: 129.333,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 13.105,
    height: 13.105
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 79.444,
    y1: 135.886,
    x2: 117.667,
    y2: 135.886
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.333,
    y: 149.333,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 13.105,
    height: 13.105
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 79.444,
    y1: 155.886,
    x2: 117.667,
    y2: 155.886
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.333,
    y: 169.333,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 13.105,
    height: 13.105
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 79.444,
    y1: 175.886,
    x2: 117.667,
    y2: 175.886
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.333,
    y: 189.333,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 13.105,
    height: 13.105
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 79.444,
    y1: 195.886,
    x2: 117.667,
    y2: 195.886
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 63.667,173.333 65.667,178.667 79.667,169.333  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 63.667,132.667 65.667,138 79.667,128.667  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.667,
    y: 226.456,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.96,
    height: 8.96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 138.733,
    y1: 230.936,
    x2: 164.866,
    y2: 230.936
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.667,
    y: 240.13,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.96,
    height: 8.96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 138.733,
    y1: 244.61,
    x2: 164.866,
    y2: 244.61
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.667,
    y: 253.804,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.96,
    height: 8.96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 138.733,
    y1: 258.284,
    x2: 164.866,
    y2: 258.284
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.667,
    y: 267.478,
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 8.96,
    height: 8.96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 138.733,
    y1: 271.958,
    x2: 164.866,
    y2: 271.958
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 127.946,256.539 129.313,260.185 138.885,253.804  "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 127.946,228.735 129.313,232.381 138.885,226  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M174.111,94.726v-5.059l-5.612-0.873c-0.277-0.993-0.666-1.936-1.162-2.815l3.348-4.582l-3.578-3.578l-4.582,3.349 c-0.878-0.496-1.822-0.885-2.815-1.162l-0.873-5.612h-5.059l-0.873,5.612c-0.993,0.277-1.937,0.666-2.815,1.162l-4.582-3.349 l-3.578,3.578l3.348,4.582c-0.496,0.878-0.885,1.822-1.162,2.815l-5.612,0.873v5.059l5.612,0.873 c0.277,0.993,0.666,1.937,1.162,2.815l-3.348,4.582l3.578,3.578l4.582-3.349c0.878,0.496,1.822,0.886,2.815,1.162l0.873,5.612 h5.059l0.873-5.612c0.993-0.277,1.936-0.666,2.815-1.162l4.582,3.349l3.578-3.578l-3.348-4.582 c0.496-0.878,0.886-1.822,1.162-2.815L174.111,94.726z M156.309,100.197c-4.418,0-8-3.582-8-8c0-4.418,3.582-8,8-8s8,3.582,8,8 C164.309,96.615,160.727,100.197,156.309,100.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M141,110.197v-3.386l-3.756-0.584c-0.185-0.664-0.445-1.296-0.778-1.884l2.241-3.066l-2.394-2.394l-3.066,2.241 c-0.588-0.332-1.219-0.593-1.884-0.778l-0.584-3.756h-3.386l-0.584,3.756c-0.664,0.185-1.296,0.446-1.884,0.778l-3.066-2.241 l-2.394,2.394l2.241,3.066c-0.332,0.588-0.592,1.219-0.778,1.884l-3.755,0.584v3.386l3.755,0.584 c0.185,0.664,0.446,1.296,0.778,1.884l-2.241,3.066l2.394,2.394l3.066-2.241c0.588,0.332,1.219,0.593,1.884,0.778l0.584,3.755 h3.386l0.584-3.755c0.664-0.185,1.296-0.446,1.884-0.778l3.066,2.241l2.394-2.394l-2.241-3.066 c0.332-0.588,0.593-1.219,0.778-1.884L141,110.197z M129.086,113.857c-2.957,0-5.354-2.397-5.354-5.354 c0-2.957,2.397-5.354,5.354-5.354s5.354,2.397,5.354,5.354C134.44,111.46,132.043,113.857,129.086,113.857z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M319.321,321.551l-2.688,4.286l4.29,3.721c-0.293,0.988-0.465,1.994-0.511,3.002l-5.271,2.103l1.13,4.932l5.661-0.402 c0.48,0.887,1.073,1.718,1.767,2.48l-2.242,5.218l4.286,2.688l3.721-4.29c0.988,0.293,1.994,0.465,3.002,0.511l2.103,5.271 l4.932-1.13l-0.402-5.661c0.887-0.48,1.718-1.073,2.48-1.767l5.218,2.242l2.688-4.286l-4.29-3.721 c0.293-0.988,0.465-1.994,0.511-3.002l5.271-2.103l-1.13-4.932l-5.661,0.402c-0.48-0.887-1.073-1.718-1.767-2.48l2.242-5.218 l-4.286-2.688l-3.721,4.29c-0.988-0.293-1.994-0.465-3.002-0.511l-2.103-5.271l-4.932,1.13l0.402,5.661 c-0.887,0.48-1.718,1.073-2.48,1.767L319.321,321.551z M337.309,326.375c3.743,2.347,4.874,7.285,2.527,11.028 c-2.348,3.743-7.285,4.874-11.028,2.527c-3.743-2.347-4.875-7.285-2.527-11.028C328.629,325.159,333.566,324.027,337.309,326.375z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "none",
      stroke: "#000000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M355.592,326.037l-1.799,2.868l2.871,2.49c-0.196,0.661-0.311,1.335-0.342,2.009l-3.527,1.407l0.756,3.3l3.788-0.269 c0.321,0.594,0.718,1.15,1.182,1.66l-1.5,3.492l2.868,1.799l2.49-2.871c0.661,0.196,1.335,0.311,2.009,0.342l1.407,3.527 l3.3-0.756l-0.269-3.788c0.594-0.322,1.15-0.718,1.66-1.183l3.492,1.5l1.799-2.868l-2.871-2.49 c0.196-0.661,0.311-1.335,0.342-2.009l3.527-1.407l-0.756-3.3l-3.788,0.269c-0.322-0.594-0.718-1.15-1.182-1.66l1.5-3.492 l-2.868-1.799l-2.49,2.871c-0.661-0.196-1.335-0.311-2.009-0.342l-1.407-3.527l-3.3,0.756l0.269,3.788 c-0.594,0.322-1.15,0.718-1.66,1.183L355.592,326.037z M367.63,329.265c2.505,1.571,3.262,4.875,1.691,7.38 c-1.571,2.505-4.875,3.262-7.38,1.691c-2.505-1.571-3.262-4.875-1.691-7.38C361.821,328.451,365.125,327.694,367.63,329.265z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Drawers_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.229,
    y: 257.871,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 134.841 562.4951)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 84.383,
    height: 46.753
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.795,
    y: 257.871,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 139.9724 562.4951)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 84.383,
    height: 46.753
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 70.331,265.095 56.329,289.347 84.333,289.347  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 397.74,
    y: 341.871,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 84.383,
    height: 46.753
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.174,
    y: 341.871,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 84.383,
    height: 46.753
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 435.855,350.753 440.329,359.818 450.333,361.272 443.094,368.328 444.803,378.292 435.855,373.588 426.907,378.292  428.616,368.328 421.376,361.272 431.381,359.818  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M236.64,258.767c0,0-32.623,9.078-34.042,12.198c-1.418,3.12-19.858,36.595-19.858,36.595l16.453,23.829l14.184-18.439 l5.106,43.687c0,0-6.241,10.212-3.971,14.751c2.27,4.539,6.241,6.241,6.241,6.241h74.324c0,0,4.539-5.39,3.404-12.482 c-1.135-7.092-3.121-15.886-3.121-15.886l-0.284-24.964l8.51-26.098l41.701-0.284l-7.092-29.219c0,0-28.935-6.241-30.921-7.376 c-1.986-1.135-11.914-3.12-16.737-3.12c-4.822,0-13.617,0-13.617,0l-37.729-0.284L236.64,258.767z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 207.317,289.539 213.379,312.95 202.031,292.525  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 205.152,
    y1: 281.178,
    x2: 206.145,
    y2: 285.015
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 196.328,
    y1: 303.428,
    x2: 191.535,
    y2: 300.752
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 213.379,
    y1: 312.95,
    x2: 198.891,
    y2: 304.86
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 309.83,274.937 303.589,298.199 316.071,274.937  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 326.706,
    y1: 284.085,
    x2: 330.538,
    y2: 281.746
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 303.589,
    y1: 298.199,
    x2: 322.547,
    y2: 286.624
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 272.577,
    y1: 334.683,
    x2: 276.072,
    y2: 331.957
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 233.52,
    y1: 365.147,
    x2: 269.873,
    y2: 336.792
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 253.945,
    y1: 345.573,
    x2: 233.52,
    y2: 360.041
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 243.449,238.342 241.747,260.753 258.484,279.476 272.951,261.604 268.413,239.477  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M268.413,239.477l-24.964-1.135l-0.429,5.649c3.731,4.325,11.197,13.802,14.22,14.557c2.534,0.633,9.045-6.633,12.65-11.87 L268.413,239.477z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 238.91,247.137 254.512,266.994 243.732,287.703 233.804,259.051  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 275.504,247.137 259.902,266.994 270.682,287.703 280.611,259.051  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M233.534,209.123c0,0-3.12-6.525-5.957-1.418c-2.837,5.106,6.241,15.319,7.376,15.319 C236.087,223.024,233.534,209.123,233.534,209.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M278.639,209.123c0,0,3.121-6.525,5.957-1.418s-6.241,15.319-7.376,15.319C276.086,223.024,278.639,209.123,278.639,209.123z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M231.575,187.564c0.223,4.646,1.878,37.405,4.512,44.254c2.837,7.376,15.886,19.29,22.127,18.723 c6.241-0.567,17.305-14.468,18.723-19.574c1.275-4.591,2.321-36.923,2.519-43.403H231.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M238.924,213.662c0,0,3.972,4.255,11.347-0.284"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M274.1,213.662 c0,0-3.972,4.255-11.347-0.284"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M253.108,224.726c0,0,2.837,5.39,9.078,0"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 254.81,
    y1: 234.371,
    x2: 259.916,
    y2: 234.371
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M237.222,206.003c0,0,1.986-1.986,12.198-0.284"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M274.384,206.003c0,0-1.986-1.986-12.198-0.284"
  }))))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M345.006,267.845 c0,0,30.637-64.395,33.758-64.679c3.12-0.284,6.808,3.971,5.674,9.645s-16.737,60.14-20.141,71.487 c-3.404,11.347-7.943,15.886-11.631,14.468C348.978,297.348,345.006,267.845,345.006,267.845z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M171.215,307.498 c0,0,15.667,35.577,19.3,34.947c3.634-0.63,14.43-11.426,14.93-13.528c0.499-2.102-6.712-13.808-13.975-19.171 c-7.263-5.363-9.608-7.26-10.726-7.066C179.626,302.873,173.026,306.32,171.215,307.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M335.645,265.859 c0,0-2.837,19.007-0.284,26.666c2.553,7.659,5.106,8.794,9.361,9.078c4.255,0.284,10.496-0.851,11.631-3.688 c1.135-2.837-9.078-30.637-10.213-32.623C345.006,263.306,339.332,263.59,335.645,265.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M117.62,298.936 c-3.28-2.311-7.07-4.245-7.07-4.245s-4.532-1.23-5.538-5.374c-1.006-4.144,4.815-5.441,4.815-5.441 c3.731-0.071,67.194,27.222,67.194,27.222c10.759,12.243,12.67,26.595,13.01,28.552c0.339,1.957-1.241,2.806-2.359,3 c-1.118,0.194-20.177-8.27-25.864-11.353c-12.075-6.545-40.629-30.099-40.629-30.099L117.62,298.936z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M88.867,308.123 c0,0-2.712,4.168-5.567,5.984c-2.855,1.816-6.613,2.995-5.41,3.843c1.204,0.848,2.619,1.395,5.563,0.092 c2.944-1.303,6.401-2.694,6.401-2.694S92.925,307.156,88.867,308.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M88.319,309.539 c0,0-2.558,8.104-5.793,10.778c-3.235,2.674-7.885,4.801-4.887,5.338c2.999,0.537,4.873-0.844,8.921-3.395 c4.049-2.551,5.276-4.613,4.688-9.53C90.662,307.812,90.016,307.132,88.319,309.539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M88.6,306.585 c0,0-0.24,9.287-0.855,13.356s-8.269,11.735-5.058,11.971c3.211,0.236,8.891-8.145,10.197-11.277 c1.306-3.132,2.243-3.823,1.241-6.555C93.124,311.348,89.393,303.541,88.6,306.585z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6772 -0.7358 0.7358 0.6772 -209.6287 184.225)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 105.141,
    cy: 331.02,
    rx: 13.694,
    ry: 13.694
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M115.727,286.298c0,0-8.46-4.61-12.419-1.546c-3.96,3.064-12.854,17.285-15.788,20.171c-2.934,2.886,2.547,10.125,4.428,16.403 s0.373,11.294,3.618,10.204c3.245-1.091,1.898-4.291,2.114-10.668c0.216-6.377-2.345-12.009-2.222-12.823 c0.123-0.814,6.514-5.091,10.672-3.963c4.158,1.129,6.23,3.939,5.994,7.15c-0.236,3.211-2.616,12.341-1.402,14.772 c1.214,2.431,3.443,3.102,4.784-1.357c1.341-4.459,4.924-12.741,5.673-16.04c0.749-3.3-6.579-18.144-6.579-18.144"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M97.99,342.701 c-3.925-2.408-6.542-6.739-6.542-11.681c0-7.402,5.872-13.432,13.212-13.686"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M409.585,213.385c0,0,4.358,2.395,7.732,2.648c3.374,0.253,7.244-0.481,6.583,0.835c-0.661,1.316-1.651,2.466-4.861,2.707 c-3.211,0.241-6.915,0.646-6.915,0.646S405.55,214.447,409.585,213.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M410.736,214.375c0,0,6.08,5.938,10.194,6.768c4.114,0.831,9.218,0.511,6.827,2.399c-2.39,1.889-4.695,1.555-9.468,1.217 c-4.773-0.338-6.829-1.576-8.631-6.189C407.855,213.958,408.104,213.053,410.736,214.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M409.094,211.902c0,0,4.595,8.075,7.058,11.372c2.463,3.297,12.829,6.444,10.109,8.167c-2.719,1.724-11.683-2.984-14.313-5.129 c-2.63-2.145-3.782-2.312-4.188-5.193C407.354,218.237,406.958,209.594,409.094,211.902z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.93,
    y: 231.904,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 21.109,
    height: 21.109
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M375.603,206.82 c0,0,5.283-8.057,10.22-7.225c4.937,0.832,19.491,9.172,23.44,10.332c3.949,1.16,2.533,10.129,3.838,16.551 c1.305,6.423,5.003,10.133,1.627,10.703c-3.376,0.57-3.699-2.888-6.899-8.408c-3.2-5.521-3.6-11.695-4.093-12.354 c-0.493-0.659-8.146-1.414-11.279,1.543c-3.133,2.958-3.633,6.414-1.91,9.133s8.131,9.645,8.209,12.362 c0.077,2.716-1.572,4.36-4.858,1.061c-3.286-3.299-10.355-8.909-12.573-11.464c-2.218-2.556-2.764-19.101-2.764-19.101"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 403.53,231.906 414.039,231.906 414.039,242.57  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M220.754,377.629 l-5.028,18.757l-53.658-2.316c0,0,32.426,26.636,48.253,32.04c15.827,5.404,37.444,11.195,55.588,9.651 c18.143-1.544,35.9-5.018,54.044-13.897s28.952-26.25,28.952-26.25h-51.341l-2.486-17.985H220.754z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M297.228,420.813c0,0,12.344,0.908,21.228-1.384c8.885-2.292,15.299,2.091,16.113,10.385c0.814,8.293-3.343,15.907-14.366,16.738 c-11.023,0.831-26.789-6.389-26.789-6.389S289.089,429.051,297.228,420.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M309.722,445.197c0,0,10.212,2.451,15.118-2.574c4.906-5.025,5.897-12.273,4.355-17.968c-1.074-3.966-4.234-5.351-6.057-5.828 c6.396,0.078,10.769,4.236,11.432,10.987c0.814,8.293-3.343,15.907-14.366,16.738c-3.907,0.295-8.408-0.424-12.593-1.472 L309.722,445.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M293.812,424.248c0,0,6.165,2.741,11.248,2.592c5.083-0.149,7.209,4.361,4.036,7.513c-3.173,3.152-16.379-0.551-17.536-1.342 C290.402,432.22,290.752,426.572,293.812,424.248z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M236.192,391.921 c-19.377-8.619-38.535-18.569-55.928-30.032c-9.196-6.061-18.392-8.36-26.335-1.881c-7.942,6.479-7.524,20.691-1.045,28.007 c6.479,7.315,26.544,14.63,45.563,22.572c19.019,7.942,57.476,17.138,68.553,20.064c11.077,2.926,14.212,4.807,16.929,7.315 c2.717,2.508,9.485,2.196,9.485,2.196s-0.079-8.466,1.802-12.437c1.881-3.971,3.135-6.688,3.135-6.688s-3.344-2.508-6.479-4.807 c-3.135-2.299-3.971-0.627-10.451-4.808c-7.161-4.619-15.939-7.392-23.813-10.514 C250.491,398.087,243.327,395.094,236.192,391.921z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M202.216,423.022c0,0-12.353-0.772-20.845-4.246c-8.493-3.474-15.441,0-17.371,8.107c-1.93,8.107,1.158,16.213,11.967,18.529 c10.809,2.316,27.408-2.702,27.408-2.702S209.164,432.287,202.216,423.022z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M186.534,445.49 c0,0-10.45,1.045-14.63-4.598s-4.18-12.958-1.881-18.392c1.601-3.784,4.92-4.728,6.791-4.954 c-6.347-0.789-11.244,2.739-12.815,9.337c-1.93,8.107,1.158,16.213,11.967,18.529c3.831,0.821,8.388,0.719,12.676,0.247 L186.534,445.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M205.135,426.889 c0,0-6.479,1.881-11.495,1.045c-5.016-0.836-7.733,3.344-5.016,6.897c2.717,3.553,16.302,1.672,17.556,1.045 C207.435,435.249,207.853,429.606,205.135,426.889z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M217.271,419.934 c0,0,71.415-29.338,96.892-43.235c25.478-13.897,44.007-9.651,44.007,5.404c0,15.055-20.845,25.092-37.445,32.426 c-16.599,7.335-81.065,22.39-88.4,23.548c-7.335,1.158-8.493,1.544-8.493,1.544s-3.86,4.246-5.018,4.632 c-1.158,0.386-16.985-2.316-16.985-2.316s3.86-8.107,2.702-11.581c-1.158-3.474-2.316-7.335-2.316-7.335 S211.094,416.46,217.271,419.934z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Drawers_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 439.646,
    y: 262.717,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 42.477,
    height: 36.49
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.646,
    y: 270.068,
    style: {
      fill: "#B0B0B0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 42.477,
    height: 29.139
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.53,
    y: 257.871,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 84.383,
    height: 46.753
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.964,
    y: 257.871,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 84.383,
    height: 46.753
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.263,
    y: 269.132,
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 21.109,
    height: 21.109
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.229,
    y: 346.717,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 92.9344 729.9249)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 42.477,
    height: 36.49
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.229,
    y: 354.068,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 92.9344 737.2755)",
    style: {
      fill: "#B0B0B0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 42.477,
    height: 29.139
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.438,
    y: 341.871,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 203.26 730.4951)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 84.383,
    height: 46.753
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.004,
    y: 341.871,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 208.3914 730.4951)",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 84.383,
    height: 46.753
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7361 -0.6769 0.6769 0.7361 -219.4612 168.4433)",
    style: {
      fill: "#92E3A9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 106.284,
    cy: 365.663,
    rx: 13.488,
    ry: 13.488
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentmoThinking);
export default __webpack_public_path__ + "static/media/sentmo-thinking.c6e4ab77c102a6a42f5c87325cc1474d.svg";
export { ForwardRef as ReactComponent };